// API Configuration
export const API_BASE_URL = 'http://146.190.178.67:3001'; 